<template>
  <div class="page-view">
      <div class="col">
        <div class="clearfix">
          <div class="row">
            <div class="col-12">
              <info-page-not-found />
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import InfoPageNotFound from '@/components/common/infos/infoPageNotFound';

export default {
  name: 'PageNotFound',
  components: { InfoPageNotFound },
};
</script>
